import { lazy } from './lazyWithRetry';
import { Route } from 'react-router-dom';
import { suspense } from './utils';
import NotificationsList from 'app/features/notifications/NotificationsList';

export default function NotificationsRoutes() {
  return <Route path="notifications" element={<NotificationsList />} />;
}
